// import { apiRequest } from "./api/axiosInstance";

import axios from "axios";
import { baseUrl } from "../config";
import axiosInstance, { apiRequest } from "./axiosInstance";

// // Example: GET with params
// apiRequest({
//   url: "/projects",
//   method: "GET",
//   params: { location: "Goa" },
// })
//   .then((res) => console.log(res.data))
//   .catch((err) => console.error(err));

// // Example: POST with body
// apiRequest({
//   url: "/projects",
//   method: "POST",
//   data: { name: "New Project", price: "20L" },
// })
//   .then((res) => console.log(res.data))
//   .catch((err) => console.error(err));

export const createUserApi = async (userdata) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: "/user/createUser",
      method: "POST",
      data: userdata,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};

export const loginUserApi = async (userdata) => {
  try {
    let data = await axios.post(`${baseUrl}/user/login`, userdata);
    return data?.data;
  } catch (error) {
    return error?.response?.data || { message: error?.message || "Login failed", sucess: false };
  }
};

// export const getAllUsersApi = async (userdata) => {
//   try {
//     let data = await axios.get(`${baseUrl}/user/`);
//     return data?.data;
//   } catch (error) {
//     return error?.response?.data;
//   }
// };

export const getAllUsersApi = async (params)=>{
    const response = await apiRequest({
        url: "/user/",
        method: "GET",
        params:params
      });
      return response?.data
}

export const updateUserPassword = async (userdata, token) => {
  try {
    // let data= await axiosInstance.post(`${baseUrl}/user/update-password`,userdata)
    let data = await axios.post(`${baseUrl}/user/update-password`, userdata, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return data?.data;
  } catch (error) {
    return { error: error?.response?.data };
  }
};

export const searchUserApi = async (data) => {
  try {
    let res = await axios.get(`${baseUrl}/user/searchUser?searchTerm=${data}`);

    return res?.data;
  } catch (error) {
    console.log(error, "error in search");
    return { error: error?.response?.data };
  }
};
export const getUserTreeList = async (params) => {
  const response = await apiRequest({
    url: "/user/usersList",
    method: "GET",
    params: params,
  });
  return response?.data;
};

export const updateUserApi = async (id,body) => {
  const response = await apiRequest({
    url: `/user/${id}`,
    method: "PUT",
    data: body,
  });
  return response?.data;
};

export const updateUserByAdminApi = async (body) => {
  try {
    const response = await apiRequest({
      url: "/user/updateUser",
      method: "PUT",
      data: body,
    });
    return response?.data;
  } catch (error) {
    return { status: error?.response?.status, ...error?.response?.data };
  }
};
